import { h } from 'preact';
import { accessNested, joinClasses } from 'utils/utils';
import { navigateInternally } from 'utils/bolt/index';
import { getPercentageThreshold } from 'utils/visibilityChecks';
import * as actions from 'components/utils/actions';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import Button from 'components/bolt/button/button';
import BurgerMenu from 'components/bolt/burgerMenu/burgerMenu';
import HeaderExpanded from 'components/bolt/header/headerExpanded';
import Countdown from 'components/bolt/countdown/countdown';
import Modal from 'components/shared/modal/modal';
import ModalAdvert from 'components/bolt/modalAdvert/modalAdvert';
import Sound from 'components/bolt/sound/sound';

import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
	componentDidMount() {
		super.componentDidMount();
		this.modalTimeouts = {};

		this.triggerModal(() => Store.emit(actions.SHOW_MODAL, <ModalAdvert type={'shop'} appData={this.props.appData} />), 'shop');
		this.triggerModal(() => Store.emit(actions.SHOW_MODAL, <ModalAdvert appData={this.props.appData} />), 'donate');
	}

	triggerModal(callback, name) {
		this.modalTimeouts[name] = setTimeout(
			() => {
				const active = Store.get().modalActive || false;
				if (sessionStorage.getItem(`modalShown-${name}`)) {
					return;
				}
				if (active) {
					this.triggerModal(callback, name);
				} else {
					sessionStorage.setItem(`modalShown-${name}`, 'true');
					callback();
				}
			},
			// Randomize between 30 seconds and 5 minutes
			Math.random() * (1000 * 60 * 4.5) + 1000 * 60 * 0.5,
		);
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		Object.values(this.modalTimeouts).forEach(clearTimeout);
	}

	render(props) {
		const { appData, activePage, headerData, client, solidBackground, desktopSolidHeader, style, offsetTop, calRemindOpen } = props;
		const mediaRoot = props.appData?.urls?.roots?.media || '';

		const { copy } = appData;
		const { activeSection, open: navOpen } = headerData || {};

		const store = Store.get();
		const isMobile = accessNested(this.props, 'client.device', '') !== 'desktop';
		const homeActive = isMobile ? activePage === 'boltHome' : (store.homeActivePercentage ?? 1 > getPercentageThreshold(offsetTop));

		const locationClassName = activeSection || 'bolt';
		const actionData = this.getCurrentHeaderAction();

		const oneSheetOverlay = accessNested(store, 'synopsis.onesheetExpanded');
		// TODO: let trailerOverlay component itself handle hiding the burger menu if needed to better match the behaviour
		const trailerOverlayOpen = store.trailerOverlay?.overlayOpen && store.trailerOverlay?.data?.video;

		let containerStyle = {};
		if (offsetTop) {
			containerStyle.top = offsetTop + 'px';
		}

		let burgerMenuAriaLabel;

		// Should probably set the Aria label when setting the action (when calling SET_HEADER_ACTION)
		if (actionData.icon === 'burger') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$OPEN_NAV_ARIA;
		} else if (actionData.tag === 'closeNavMenu') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CLOSE_NAV_ARIA;
		} else if (actionData.tag === 'closeCalRemind') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$CALENDAR_REMINDER_CLOSE_ARIA;
		} else if (actionData.icon === 'back') {
			burgerMenuAriaLabel = copy.accessibilityCopy.$BACK_BTN_SHOWTIMES_ARIA;
		}

		return (
			<div
				class={joinClasses(`header-${activePage}`, navOpen && 'navOpen', {
					s,
					headerContainer: true,
				})}
			>
				<div
					class={joinClasses(
						{
							s,
							container: true,
							solidBackground,
							desktopSolidHeader,
						},
						s[`activeSection--${locationClassName}`],
					)}
					style={containerStyle}
					key="container"
					id="header"
				>
					<Button class={joinClasses(s.burgerMenuBtn)} trigger={this.triggerBurgerBtn} ariaLabel={burgerMenuAriaLabel} key="burgerButton">
						<BurgerMenu
							type={actionData.icon || 'burger'}
							dark={actionData.dark}
							style={actionData.style}
							homeScrolled={!homeActive}
							navOpen={navOpen}
							oneSheetOverlayOpen={oneSheetOverlay}
							trailerOverlayOpen={trailerOverlayOpen}
							calendarRemindOpen={calRemindOpen}
							widgetFullyExpanded={store.widgetFullyExpanded}
						/>
					</Button>
					<HeaderExpanded
						appData={appData}
						activePage={activePage}
						headerData={headerData}
						navOpen={navOpen}
						client={client}
						style={style}
						key="expand"
					/>
					<Sound audioRoot={`${mediaRoot}/audio`} activePage={this.props.activePage} />
				</div>
				<Modal />
			</div>
		);
	}
}
